import React, {PropTypes} from 'react';
import {I18n} from 'react-redux-i18n';

import AfricanGreyImage from '../../../images/paracheirodon_innesi.jpg';

const StyledLabel4ColLrg = ({
  logoUrl,
  styleElements
}) => {
  // Create the element styles
  const headerBackground = {background: styleElements.headerBgColor};
  const headerFont = {color: styleElements.headerFontColor};
  const detailFont = {color: styleElements.detailFontColor};
  const valueBackground = {backgroundColor: styleElements.valueBgColor};
  const valueFont = {color: styleElements.valueFontColor};
  const priceFont = {color: styleElements.priceFontColor};
  
  const pluFont = {color: styleElements.pluFontColor};
  const barCodeBackground = {backgroundColor: styleElements.barCodeBgColor};
  const priceBackground = {backgroundColor: styleElements.priceBgColor, borderColor: styleElements.labelBgColor};
  const tableRowBackground = {borderBottomColor: styleElements.labelBgColor, borderTopColor: styleElements.labelBgColor};
  const detailBackground = {backgroundColor: styleElements.detailBgColor, borderLeftColor: styleElements.labelBgColor};
  const imageBorder = {borderColor: styleElements.imageBorderColor};
  const fullLabel = {backgroundColor: styleElements.labelBgColor};
  const rightPanelBackground = {backgroundColor: styleElements.rightPanelBgColor};

  return (
    <div className="four-col-lrg label-main" style={fullLabel}>
      <div className="label-title" style={headerBackground}>
        <div className="label-left-img">
          <img src={AfricanGreyImage} style={imageBorder}/>
        </div>
        <div className="title-fields">
          <span className="label-control form-control" style={headerFont}>{I18n.t('CUSTOM_LABEL_PET_LAT_NAME')}</span>
          <span className="label-control form-control latin-name" style={headerFont}>{I18n.t('CUSTOM_LABEL_PET_NAME')}</span>
        </div>
      </div>
      <div className="label-right-col" style={rightPanelBackground}>
        <div className="label-logo" style={rightPanelBackground}>
          <img src={logoUrl} />
        </div>
        <div className="price" style={priceBackground}><span className="label-control form-control txt-price" style={priceFont}>{I18n.t('CUSTOM_LABEL_PET_PRICE')}</span></div> 
        <div className="plu"><span className="label-control form-control" style={pluFont}>12345</span></div>
        <div className="label-footer" style={barCodeBackground}><div className="barcode"/></div> 
      </div>    
      <div className="label-content">
          <table cellPadding="0" cellSpacing="0">
            <tbody>
              <tr style={tableRowBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_7')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_7')}</span></td>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_8')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_8')}</span></td>
              </tr>    
              <tr style={tableRowBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_1')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_1')}</span></td>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_9')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_9')}</span></td>
              </tr>
              <tr style={tableRowBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_4')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_4')}</span></td>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_3')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_3')}</span></td>
              </tr>
               <tr style={tableRowBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_14')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_14')}</span></td>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_11')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_11')}</span></td>
              </tr>    
              <tr style={tableRowBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_5')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_5')}</span></td>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_12')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_12')}</span></td>
              </tr>
              <tr style={tableRowBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_17')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_17')}</span></td>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_16')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_16')}</span></td>
              </tr>
              <tr style={tableRowBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_13')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_13')}</span></td>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_6')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_6')}</span></td>
              </tr>
            </tbody>
          </table>
      </div>
    </div>
  );
};

StyledLabel4ColLrg.propTypes = {
  logoUrl: PropTypes.string.isRequired,
  styleElements: PropTypes.object.isRequired
};

export default StyledLabel4ColLrg;


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/StyledLabel4ColLrg.js
 **/